import React, { createContext, useContext, useState, useCallback } from 'react';

interface ImportAssetsModalContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const ImportAssetsModalContext = createContext<ImportAssetsModalContextType | undefined>(undefined);

export function ImportAssetsModalProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <ImportAssetsModalContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
    </ImportAssetsModalContext.Provider>
  );
}

export function useImportAssetsModal() {
  const context = useContext(ImportAssetsModalContext);
  if (!context) {
    throw new Error('useImportAssetsModal must be used within ImportAssetsModalProvider');
  }
  return context;
}
